import { render, staticRenderFns } from "./iot-setting.vue?vue&type=template&id=746b3738&scoped=true"
import script from "./iot-setting.vue?vue&type=script&lang=ts"
export * from "./iot-setting.vue?vue&type=script&lang=ts"
import style0 from "./iot-setting.vue?vue&type=style&index=0&id=746b3738&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b3738",
  null
  
)

export default component.exports